// extracted by mini-css-extract-plugin
export default {"footer":"footer--H68F5","delimiter":"delimiter--FiHHw"};